export const selectFilterStore = (state) => state.filterStore;

export const selectFilterChanged = (state) =>
  selectFilterStore(state).filterChanged;

export const selectRequests = (state) => state.requestsStore.requests;

export const selectCreationMethods = (state) =>
  state.requestsStore.creationMethods;

export const selectFilterCreator = (state) =>
  selectFilterStore(state).filterCreator;

export const selectLastRequestsState = (state) =>
  state.crossPageInteractionsStore.Requests;

export const selectUserInfo = (state) => state.authentication.userInfo;

export const selectWarrantyOrganizations = (state) =>
  state.contractorStore.contractors;
